import { Injectable } from '@angular/core';
import { BehaviorSubject, distinctUntilChanged } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class TerminologyTestingStateService {
  private readonly provisionalSubject = new BehaviorSubject<boolean>(false);
  readonly provisional$ = this.provisionalSubject.asObservable().pipe(distinctUntilChanged());

  updateFromResponseMode(mode: string | null): void {
    if (mode === null) return;
    this.provisionalSubject.next(mode.toLowerCase() === 'provisional');
  }

  clear(): void {
    this.provisionalSubject.next(false);
  }
}
